<template>
  <div id="app" class="wrapper">
    <Header v-if="loading && hasSubject"></Header>
    <!-- <Top v-if="loading && !hasSubject && path != 'school_login' && path != 'asp_login' && path != 'fourfour' && path != 'denglu' && path != 'login' && path != 'video' && path != 'pdf' && path != 'register' && path != 'findpwd'"></Top> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="currentViewKey" class="view" />
    </keep-alive>
    <transition name="fade-transform" mode="out-in">
      <router-view v-if="!$route.meta.keepAlive" :key="currentViewKey" class="view" />
    </transition>
    <!-- <Bottom v-if="loading && !hasSubject && path != 'school_login' && path != 'asp_login' &&  path != 'fourfour' && path != 'denglu' && path != 'login' && path != 'video' && path != 'pdf' && path != 'answers_list' && path != 'register' && path != 'findpwd'"></Bottom> -->
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Top from "@/components/top.vue";
import Bottom from "@/components/bottom.vue";

export default {
  data() {
    return {
      path: "",
      hasSubject: false,
      loading: false,
      currentViewKey: "",
      routeViewKeys: {},
    };
  },
  watch: {
    $route: {
      handler(val) {
        this.path = val.name;
        this.hasSubject = this.$route.path.includes("subjectGateway") || this.$route.path.includes("subject-knowledge");
        this.loading = true;
        this.updateCurrentViewKey(val.path);
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
  components: {
    Top,
    Bottom,
    Header,
  },
  methods: {
    updateCurrentViewKey(path) {
      const remountPath = sessionStorage.getItem("chongda_force_remount_path");
      const remountNonce = sessionStorage.getItem("chongda_force_remount_nonce");
      if (remountPath === path && remountNonce) {
        this.routeViewKeys[path] = `${path}::${remountNonce}`;
        sessionStorage.removeItem("chongda_force_remount_path");
        sessionStorage.removeItem("chongda_force_remount_nonce");
      } else if (!this.routeViewKeys[path]) {
        this.routeViewKeys[path] = path;
      }
      this.currentViewKey = this.routeViewKeys[path] || path;
    },
  },
};
</script>

<style lang="scss">
#app {
  background: #f5f5f5;
  color: #333;
  position: relative;
  font-size: 15px;
  min-height: 100vh;
  // height: auto !important;
}

/* fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/* fade-transform */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-100px);
}
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
.line2 {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  /* -webkit-box-orient: vertical; */
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  display: -webkit-box;
  word-break: break-all;
}
.line1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-message {
  top: 80px !important;
}
</style>
